import React from "react";
import * as Yup from "yup";
import Modal from "components/Modal";
import cls from "./modal.module.scss";
import { Button } from "@duik/it";
import className from "classnames";
import { Formik, FormikProps } from "formik";
import { useDispatch } from "react-redux";
import { useRedux } from "@redux";
import FormInputGroup from "../../../../components/FormInputGroup";
import Input from "../../../../components/Input";
/**
 * Type of Formvalues
 */
interface FormValues {
  specialtiesSummary: string;
}

/**
 * Form Schema
 * @returns errors
 */
const AddspecialtiesSummarySchema = Yup.object().shape({
  specialtiesSummary: Yup.string().required("Summary is empty"),
});

export const AddspecialtiesSummary = ({
  handleClose,
  isOpen,
  customerProfiledata,
  handleDelete,
  handleUpdate,
}) => {
  const dispatch = useDispatch();

  const customerProfileState = useRedux("customerProfile");
  const [isDeleting, setIsDeleting] = React.useState(false);
  // Inital formvalues
  const initialValues: FormValues = {
    specialtiesSummary: customerProfiledata.config?.specialtiesSummary || "",
  };

  React.useEffect(() => {
    if (!customerProfileState.isUpdating) {
      setIsDeleting(false);
      handleClose();
    }
  }, [customerProfileState.isUpdating]);
  // Handle update
  const handleUpdateSummary = (data: any, actions: any) => {
    handleUpdate(data, customerProfiledata.id);
  };
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      className={cls.modalWrapper}
    >
      <h2>
        {!customerProfiledata.config?.specialtiesSummary
          ? "Edit Notes"
          : "Add Notes"}
      </h2>
      <br />
      <br />
      <Formik
        initialValues={initialValues}
        validationSchema={AddspecialtiesSummarySchema}
        onSubmit={handleUpdateSummary}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
          handleBlur,
          values,
        }: FormikProps<FormValues>) => (
          <form onSubmit={handleSubmit}>
            <FormInputGroup>
              <FormInputGroup horizontal className={cls.summaryInput}>
                <Input
                  type="textarea"
                  label="NOTES"
                  name="specialtiesSummary"
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  errorMessage={
                    errors.specialtiesSummary && touched.specialtiesSummary
                      ? errors.specialtiesSummary
                      : undefined
                  }
                  value={values?.specialtiesSummary || ""}
                  placeholder="Notes..."
                />
              </FormInputGroup>
              <br />
              <Button
                isLoading={customerProfileState.isUpdating}
                className={className(cls.button, cls.modalBtn, cls.submitBtn)}
                type="submit"
              >
                SAVE NOTES
              </Button>
              {!customerProfileState.isUpdating && (
                <Button
                  className={className(cls.button, cls.modalBtn)}
                  style={{ backgroundColor: "transparent" }}
                  onClick={handleClose}
                >
                  CANCEL
                </Button>
              )}
              <br/>
              {!customerProfileState.isUpdating &&
                customerProfiledata.config?.specialtiesSummary && (
                  <Button
                    className={className(
                      cls.button,
                      cls.modalBtn,
                      cls.deleteBtn
                    )}
                    isLoading={isDeleting && customerProfileState.isUpdating}
                    onClick={() => {
                      setIsDeleting(true);
                      handleDelete(customerProfiledata.id);
                    }}
                  >
                    DELETE NOTES
                  </Button>
                )}
            </FormInputGroup>
          </form>
        )}
      </Formik>
      <div style={{ height: 25 }} />
      <div style={{ height: 20 }} />
    </Modal>
  );
};
export default AddspecialtiesSummary;
